import React from 'react'
import PropTypes from 'prop-types'

import './WebinarHtmlDescriptionComponent.scss'

/**
 * WebinarHtmlDescriptionComponent is meant to be a generic
 *  component, that can render webinar description html in
 *  the same fashion everywhere.
 *
 * It is by design that the formatted styles are abstracted
 *  away in the `Html` styled component.
 *
 * Please think twice before changing the styles or the inter-
 *  face of WebinarHtmlDescriptionComponent.
 */

export const Html = ({ className, ...props }) => (
  <div
    className={['webinar-html-description', className]
      .filter(Boolean)
      .join(' ')}
    {...props}
  />
)

Html.propTypes = {
  className: PropTypes.string,
}

export const WebinarHtmlDescriptionComponent = ({ html }) => (
  <Html dangerouslySetInnerHTML={{ __html: html }} />
)

WebinarHtmlDescriptionComponent.propTypes = {
  html: PropTypes.string.isRequired,
}
